"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _phrase = _interopRequireDefault(require("@insided/deprecated-libs/translationsUtils/phrase"));

var ShowMoreButton = function ShowMoreButton(_ref) {
  var quickLinksLength = _ref.quickLinksLength,
      itemsPerContainer = _ref.itemsPerContainer,
      showMore = _ref.showMore,
      showAll = _ref.showAll;
  return (0, _preact.h)("div", {
    className: "content--centered is-hidden-mobile-only"
  }, (0, _preact.h)("button", {
    className: "btn--cta m-b-0",
    onClick: showMore
  }, (0, _preact.h)("span", {
    className: !showAll ? 'is-hidden' : undefined
  }, (0, _preact.h)(_phrase.default, {
    p: "quick.links.show.less"
  })), !showAll && (0, _preact.h)(_phrase.default, {
    p: "quick.links.show.more",
    count: {
      number: quickLinksLength - itemsPerContainer
    }
  }), (0, _preact.h)("i", {
    className: "icon--auto-width icon--caret-".concat(showAll ? 'up' : 'down', " quicklink__caret")
  })));
};

var _default = ShowMoreButton;
exports.default = _default;